const SCHEME_TRANSITION = 'transition';
const SCHEME_TRANSFORM = 'transform';
const RANDOM_CHARACTERS = '$#%&!()=/*-_.             abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';

export { SCHEME_TRANSITION, SCHEME_TRANSFORM, RANDOM_CHARACTERS };
